const ShadowLightValues = Object.freeze({
    tint1: {
        color: '#00000024',
        x: 0,
        y: 0,
        blur: 16,
        spread: 0,
    },
    tint2: {
        color: '#00000038',
        x: 0,
        y: 0,
        blur: 16,
        spread: 0,
    },
    tint3: {
        color: '#00000061',
        x: 0,
        y: 0,
        blur: 16,
        spread: 0,
    },
});
const ShadowDarkValues = Object.freeze({
    tint1: {
        color: '#00000024',
        x: 0,
        y: 0,
        blur: 16,
        spread: 0,
    },
    tint2: {
        color: '#00000038',
        x: 0,
        y: 0,
        blur: 16,
        spread: 0,
    },
    tint3: {
        color: '#00000061',
        x: 0,
        y: 0,
        blur: 16,
        spread: 0,
    },
});

export { ShadowDarkValues, ShadowLightValues };
